import { useEffect } from 'react';
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom';
import PopupRemove from '../Meetings/popup-remove'

const CancelBrokerTour = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const canceldata = useSelector(state => state.meeting.cancel);

  useEffect(() => {
    document.title = 'Отменить брокер-тур | Личный кабинет Брокера THE FIVE';

  }, [])

  if(canceldata === null) {
    return navigate(location.state.back + location.state.hash, {state: {hash: location.state.hash.split('#')[1]} })
  }

  return (    
    <PopupRemove data={canceldata} />
  )
}

export default CancelBrokerTour